import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IFeedback } from '../../interfaces/IFeedback.interface';
import { FeedbackApiService } from '../../services/feedback-api.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-feedback-container',
  template: `
    <app-feedback [inProgress]="inProgress" (onSendFeedback)="onSendFeedback($event)"></app-feedback>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackContainerComponent {
  inProgress = false;
  dialogRef!: MatDialogRef<FeedbackContainerComponent>;

  constructor(private _dialog: MatDialog, private _feedbackApi: FeedbackApiService, private _cdr: ChangeDetectorRef) {}

  onSendFeedback(data: IFeedback): void {
    this.inProgress = true;
    this._feedbackApi.sendFeedback(data).subscribe({
      next: () => {
        this.dialogRef.close();
      },
      complete: () => {
        this.inProgress = false;
        this._cdr.markForCheck();
      },
    });
  }
}
